<template>
	<div class="result_content">
		<div class="tips">截屏保存分享图片给好友</div>
		<a class="logo" href="https://m.xubei.com/"><img src="/static/images/logo.png" /></a>
		<div class="zh_guzhi">
			<div class="avatar" v-if="avatar"><img :src="avatar" /></div>
			<div class="avatar" v-if="!avatar"><img src="/static/images/defalut_avatar.png" /></div>
			<div class="wenan">{{ msgData.username }}</div>
			<div class="pmd">
				<span class="z1">￥</span>
				<!-- <span class="z2" id="num">{{msgData.amountValue}}</span> -->
				<div class="z2" id="num">{{ msgData.amountValue }}</div>
			</div>
		</div>
		<div class="zh_price" v-if="msgData.id == 1 && msgData.amountValue / 40078 < 1">
			您的账号价值超过了全国
			<span>{{ Math.floor((msgData.amountValue / 40078) * 100) }}%</span>
			的玩家
		</div>
		<div class="zh_price" v-if="msgData.id == 1 && msgData.amountValue / 40078 == 1">
			您的账号价值超过了全国
			<span>99%</span>
			的玩家
		</div>

		<div class="zh_price" v-if="msgData.id == 2 && msgData.amountValue / 85816 < 1">
			您的账号价值超过了全国
			<span>{{ Math.floor((msgData.amountValue / 85816) * 100) }}%</span>
			的玩家
		</div>
		<div class="zh_price" v-if="msgData.id == 2 && msgData.amountValue / 85816 == 1">
			您的账号价值超过了全国
			<span>99%</span>
			的玩家
		</div>

		<div class="zh_price" v-if="msgData.id == 3 && msgData.amountValue / 101700 < 1">
			您的账号价值超过了全国
			<span>{{ Math.floor((msgData.amountValue / 101700) * 100) }}%</span>
			的玩家
		</div>
		<div class="zh_price" v-if="msgData.id == 3 && msgData.amountValue / 101700 == 1">
			您的账号价值超过了全国
			<span>99%</span>
			的玩家
		</div>

		<div class="zh_price" v-if="msgData.id == 4 && msgData.amountValue / 307216 < 1">
			您的账号价值超过了全国
			<span>{{ Math.floor((msgData.amountValue / 307216) * 100) }}%</span>
			的玩家
		</div>
		<div class="zh_price" v-if="msgData.id == 4 && msgData.amountValue / 307216 == 1">
			您的账号价值超过了全国
			<span>99%</span>
			的玩家
		</div>

		<div class="myTag">
			<div class="utip">{{ random_txt }}</div>
			<div class="renzheng">
				<div class="yz">
					<img src="/static/images/yz.png" />
					<router-link to="/" class="fh">再测一次</router-link>
				</div>
				<div class="ewm">
					<img src="/static/images/ewm.png" />
					<div class="tx">长按查看账号价值</div>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<div class="fh" @click="dsBtn" v-if="isShowBtn"><img src="/static/images/dsbtn.png" /></div>
			<div class="gz">
				<a :href="'/rank'"><img src="/static/images/dsbtn2.png" /></a>
			</div>
		</div>

		<div class="copyright"><img src="/static/images/copy_right.png" /></div>

		<div class="modalPage" v-if="isShare" @click="closeModal">
			<img src="/static/images/shareTip.png" />
			>
		</div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui';
import { PROXY_URL } from '../../config/env';
export default {
	name: 'result',
	components: { Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			amountValue: this.$route.query.amountValue,
			msgData: JSON.parse(localStorage.getItem('msgData')),
			isShare: false,
			isShowBtn: false,
			random_txt: '',
			radomArray: [],
			avatar: localStorage.getItem('avatar')
		};
	},
	mounted() {
		console.log(this.avatar);

		var _this = this;
		var shareFn = function () {
			_this.ajax
				.get(
					PROXY_URL.config +
						'/xubei-common-cloud/anon/weixin/gzh/get/jsapi_config?url=' +
						encodeURIComponent(window.location.href.split('#').shift())
				)
				.then(res => {
					console.log(res);
					if (res.data.code == 1) {
						// 分享配置

						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: res.data.result.appId, // 必填，企业号的唯一标识
							timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳
							nonceStr: res.data.result.nonceStr, // 必填，生成签名的随机串
							signature: res.data.result.signature, // 必填，签名，见附录1
							jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
						});

						wx.ready(function () {
							wx.onMenuShareAppMessage({
								title: _this.random_txt,
								desc:
									'我的游戏账号价值￥' +
									JSON.parse(localStorage.getItem('msgData')).amountValue +
									'元，游戏签"' +
									_this.random_txt +
									'"，快来看看你的游戏账号值多少',
								link: 'http://b.xubei.com/gz',
								imgUrl: 'http://static.xubei.com/assets/images/logo_share.png',
								type: '',
								dataUrl: '',
								success: function () {},
								cancel: function () {}
							});
							wx.onMenuShareTimeline({
								title: _this.random_txt,
								desc:
									'我的游戏账号价值￥' +
									JSON.parse(localStorage.getItem('msgData')).amountValue +
									'元，游戏签"' +
									_this.random_txt +
									'"，快来看看你的游戏账号值多少',
								link: 'http://b.xubei.com/gz',
								imgUrl: 'http://static.xubei.com/assets/images/logo_share.png',
								success: function () {},
								cancel: function () {}
							});
						});

						wx.error(function (res) {
							console.log(res);
						});
					}
				})
				.catch(error => {});
		};

		if ('undefined' == typeof wx) {
			if (document.addEventListener) {
				document.addEventListener('WeixinJSBridgeReady', shareFn, false);
			} else if (document.attachEvent) {
				document.attachEvent('WeixinJSBridgeReady', shareFn);
				document.attachEvent('onWeixinJSBridgeReady', shareFn);
			}
		} else {
			shareFn();
		}

		(function () {
			'use strict';
			'object' != typeof window.CP && (window.CP = {}),
				(window.CP.PenTimer = {
					programNoLongerBeingMonitored: !1,
					timeOfFirstCallToShouldStopLoop: 0,
					_loopExits: {},
					_loopTimers: {},
					START_MONITORING_AFTER: 2e3,
					STOP_ALL_MONITORING_TIMEOUT: 5e3,
					MAX_TIME_IN_LOOP_WO_EXIT: 2200,
					exitedLoop: function (o) {
						this._loopExits[o] = !0;
					},
					shouldStopLoop: function (o) {
						if (this.programKilledSoStopMonitoring) return !0;
						if (this.programNoLongerBeingMonitored) return !1;
						if (this._loopExits[o]) return !1;
						var t = this._getTime();
						if (0 === this.timeOfFirstCallToShouldStopLoop) return (this.timeOfFirstCallToShouldStopLoop = t), !1;
						var i = t - this.timeOfFirstCallToShouldStopLoop;
						if (i < this.START_MONITORING_AFTER) return !1;
						if (i > this.STOP_ALL_MONITORING_TIMEOUT) return (this.programNoLongerBeingMonitored = !0), !1;
						try {
							this._checkOnInfiniteLoop(o, t);
						} catch (o) {
							return this._sendErrorMessageToEditor(), (this.programKilledSoStopMonitoring = !0), !0;
						}
						return !1;
					},
					_sendErrorMessageToEditor: function () {
						try {
							if (this._shouldPostMessage()) {
								var o = { action: 'infinite-loop', line: this._findAroundLineNumber() };
								parent.postMessage(o, '*');
							} else this._throwAnErrorToStopPen();
						} catch (o) {
							this._throwAnErrorToStopPen();
						}
					},
					_shouldPostMessage: function () {
						return document.location.href.match(/boomerang/);
					},
					_throwAnErrorToStopPen: function () {
						throw "We found an infinite loop in your Pen. We've stopped the Pen from running. Please correct it or contact support@codepen.io.";
					},
					_findAroundLineNumber: function () {
						var o = new Error(),
							t = 0;
						if (o.stack) {
							var i = o.stack.match(/boomerang\S+:(\d+):\d+/);
							i && (t = i[1]);
						}
						return t;
					},
					_checkOnInfiniteLoop: function (o, t) {
						if (!this._loopTimers[o]) return (this._loopTimers[o] = t), !1;
						var i = t - this._loopTimers[o];
						if (i > this.MAX_TIME_IN_LOOP_WO_EXIT) throw 'Infinite Loop found on loop: ' + o;
					},
					_getTime: function () {
						return +new Date();
					}
				}),
				(window.CP.shouldStopExecution = function (o) {
					var t = window.CP.PenTimer.shouldStopLoop(o);
					return (
						t === !0 &&
							console.warn(
								'[CodePen]: An infinite loop (or a loop taking too long) was detected, so we stopped its execution. Sorry!'
							),
						t
					);
				}),
				(window.CP.exitedLoop = function (o) {
					window.CP.PenTimer.exitedLoop(o);
				});
		})();

		// 数字滚动效果
		var num = document.querySelector('#num').innerHTML;
		play(num);

		function play(num) {
			var threshold = 10;
			var html = '';
			var arr = String(num).split('');
			var len = arr.length;
			for (var i = 0; i < len; i++) {
				if (window.CP.shouldStopExecution(0)) break;
				if (arr[i] == '.') {
					html += '.';
					continue;
				}
				html += '<div id="num_' + i + '" class="num_n" data-id="' + i + '">';
				html += retuen10(threshold);
				html += '</div>';
			}
			window.CP.exitedLoop(0);
			document.querySelector('#num').innerHTML = html;
			var num = document.querySelectorAll('.num_n');
			var spanHeight = num[0].querySelector('span').offsetHeight;
			var numlen = num.length;
			for (var j = 0; j < numlen; j++) {
				if (window.CP.shouldStopExecution(1)) break;
				var newi = document.createElement('i');
				newi.innerHTML = arr[num[j].getAttribute('data-id')];
				num[j].querySelector('span').appendChild(newi);
				num[j].querySelector('span').style.webkitTransition = 'all ' + (0.9 + j * 0.1) + 's ease-in .2s';
				num[j].querySelector('span').style.webkitTransform = 'translate3d(0,-' + spanHeight + 'px,0)';
			}
			window.CP.exitedLoop(1);
		}

		function retuen10(num) {
			var html = '';
			html += '<span>';
			for (var i = 0; i < num; i++) {
				if (window.CP.shouldStopExecution(2)) break;
				for (var j = 0; j < 10; j++) {
					if (window.CP.shouldStopExecution(3)) break;
					html += '<i>' + j + '</i>';
				}
				window.CP.exitedLoop(3);
			}
			window.CP.exitedLoop(2);
			html += '</span>';
			return html;
		}

		var ua = navigator.userAgent.toLowerCase();
		var isWeixin = ua.indexOf('micromessenger') != -1;
		if (isWeixin) {
			this.isShowBtn = true;
		} else {
			this.isShowBtn = false;
		}

		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});

		this.getWenan();
	},
	methods: {
		reload() {
			location.reload();
		},
		dsBtn() {
			this.isShare = true;
		},
		closeModal() {
			this.isShare = false;
		},
		getWenan() {
			var _this = this;
			this.ajax
				.get(PROXY_URL.config + '/xubei-page-cloud/anon/cms/getPageDataByPageId?pageId=lb_wenan')
				.then(res => {
					//王者荣耀
					if (res.data.code == 1) {
						if (this.msgData.id == 1) {
							if (this.msgData.amountValue > 0 && this.msgData.amountValue <= 3999) {
								console.log(res.data.result.mods['gear_one']);
								for (var i in res.data.result.mods['gear_one'].datas) {
									this.radomArray.push(res.data.result.mods['gear_one'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 4000 && this.msgData.amountValue <= 7999) {
								console.log(res.data.result.mods['gear_two']);
								for (var i in res.data.result.mods['gear_two'].datas) {
									this.radomArray.push(res.data.result.mods['gear_two'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 8000 && this.msgData.amountValue <= 15999) {
								console.log(res.data.result.mods['gear_three']);
								for (var i in res.data.result.mods['gear_three'].datas) {
									this.radomArray.push(res.data.result.mods['gear_three'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 16000 && this.msgData.amountValue <= 25999) {
								console.log(res.data.result.mods['gear_four']);
								for (var i in res.data.result.mods['gear_four'].datas) {
									this.radomArray.push(res.data.result.mods['gear_four'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 26000 && this.msgData.amountValue <= 40078) {
								console.log(res.data.result.mods['gear_five']);
								for (var i in res.data.result.mods['gear_five'].datas) {
									this.radomArray.push(res.data.result.mods['gear_five'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}
						}

						//英雄联盟
						//0-10000　10001-20000　20001-40000　40001-65999　66000-85816
						if (this.msgData.id == 2) {
							if (this.msgData.amountValue > 0 && this.msgData.amountValue <= 10000) {
								for (var i in res.data.result.mods['gear_one'].datas) {
									this.radomArray.push(res.data.result.mods['gear_one'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 10001 && this.msgData.amountValue <= 20000) {
								for (var i in res.data.result.mods['gear_two'].datas) {
									this.radomArray.push(res.data.result.mods['gear_two'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 20001 && this.msgData.amountValue <= 40000) {
								for (var i in res.data.result.mods['gear_three'].datas) {
									this.radomArray.push(res.data.result.mods['gear_three'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 40001 && this.msgData.amountValue <= 65999) {
								for (var i in res.data.result.mods['gear_four'].datas) {
									this.radomArray.push(res.data.result.mods['gear_four'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 66000 && this.msgData.amountValue <= 85816) {
								for (var i in res.data.result.mods['gear_five'].datas) {
									this.radomArray.push(res.data.result.mods['gear_five'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}
						}

						//0-9999　10000-19999　20000-49999　50000-79999　80000-101700
						if (this.msgData.id == 3) {
							if (this.msgData.amountValue > 0 && this.msgData.amountValue <= 9999) {
								for (var i in res.data.result.mods['gear_one'].datas) {
									this.radomArray.push(res.data.result.mods['gear_one'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 10000 && this.msgData.amountValue <= 19999) {
								for (var i in res.data.result.mods['gear_two'].datas) {
									this.radomArray.push(res.data.result.mods['gear_two'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 20000 && this.msgData.amountValue <= 49999) {
								for (var i in res.data.result.mods['gear_three'].datas) {
									this.radomArray.push(res.data.result.mods['gear_three'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 50000 && this.msgData.amountValue <= 79999) {
								for (var i in res.data.result.mods['gear_four'].datas) {
									this.radomArray.push(res.data.result.mods['gear_four'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 80000 && this.msgData.amountValue <= 101700) {
								for (var i in res.data.result.mods['gear_five'].datas) {
									this.radomArray.push(res.data.result.mods['gear_five'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}
						}

						//0-8888 8889-43888 43888-88888 88889-128888 128889-307216
						if (this.msgData.id == 4) {
							if (this.msgData.amountValue > 0 && this.msgData.amountValue <= 8888) {
								for (var i in res.data.result.mods['gear_one'].datas) {
									this.radomArray.push(res.data.result.mods['gear_one'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 8889 && this.msgData.amountValue <= 43888) {
								for (var i in res.data.result.mods['gear_two'].datas) {
									this.radomArray.push(res.data.result.mods['gear_two'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 43888 && this.msgData.amountValue <= 88888) {
								for (var i in res.data.result.mods['gear_three'].datas) {
									this.radomArray.push(res.data.result.mods['gear_three'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 88889 && this.msgData.amountValue <= 128888) {
								for (var i in res.data.result.mods['gear_four'].datas) {
									this.radomArray.push(res.data.result.mods['gear_four'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}

							if (this.msgData.amountValue > 128889 && this.msgData.amountValue <= 307216) {
								for (var i in res.data.result.mods['gear_five'].datas) {
									this.radomArray.push(res.data.result.mods['gear_five'].datas[i].properties.text);
									var index = Math.floor(Math.random() * this.radomArray.length);
									this.random_txt = this.radomArray[index];
								}
							}
						}
					}
				})
				.catch(error => {});
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.result_content {
	width: 10rem;
	margin: 0 auto;
	background: #000000 url(/static/images/ubg.jpg) no-repeat;
	background-size: 100% auto;
	.tips {
		background: #000;
		height: px2rem(55rem);
		line-height: px2rem(55rem);
		color: #fbe849;
		font-size: px2rem(30rem);
		text-align: center;
		font-weight: 700;
	}
	.logo {
		padding: px2rem(10rem) 0 px2rem(10rem) px2rem(50rem);
		display: block;
		img {
			width: px2rem(278rem);
			height: px2rem(52rem);
		}
	}
	.zh_guzhi {
		background: url(/static/images/gz_bg.png) no-repeat;
		background-size: contain;
		margin: 0 auto;
		width: px2rem(476rem);
		height: px2rem(265rem);
		position: relative;

		.avatar {
			width: px2rem(83rem);
			height: px2rem(83rem);
			border: px2rem(8rem) solid #e9af50;
			border-radius: 50%;
			position: absolute;
			left: px2rem(-39rem);
			top: px2rem(10rem);
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
	}

	.wenan {
		background: #34271f;
		color: #ffddb5;
		padding: 0 px2rem(10rem);
		width: px2rem(370rem);
		height: px2rem(55rem);
		line-height: px2rem(55rem);
		border-radius: px2rem(5rem);
		position: absolute;
		left: px2rem(55rem);
		top: px2rem(35rem);
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	.pmd {
		background: url(/static/images/pmd.png) no-repeat;
		width: px2rem(427rem);
		height: px2rem(86rem);
		line-height: px2rem(86rem);
		background-size: contain;
		position: absolute;
		left: px2rem(15rem);
		bottom: px2rem(15rem);
		font-size: px2rem(45rem);
		overflow: hidden;
		.z1 {
			color: #fff;
			float: left;
			width: px2rem(63rem);
			text-align: center;
		}
		.z2 {
			color: #fff;
			float: right;
			letter-spacing: px2rem(20rem);
		}
	}
	.zh_price {
		color: #ffddb5;
		text-align: center;
		padding: px2rem(24rem) 0 px2rem(40rem) 0;
		font-size: px2rem(32rem);
		span {
			color: #fbe849;
		}
	}
	.myTag {
		background: url(/static/images/kuang.png) no-repeat;
		background-size: 100% auto;
		width: px2rem(630rem);
		height: px2rem(471rem);
		margin: 0 auto;
		padding-top: px2rem(67rem);

		.utip {
			background: #34271f;
			color: #ffddb5;
			padding: px2rem(30rem);
			border-radius: px2rem(5rem);
			width: px2rem(576rem);
			margin: 0 auto;
			font-size: px2rem(28rem);
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.renzheng {
			display: flex;
			margin-top: px2rem(30rem);
			.yz {
				flex: 1;
				text-align: center;
				a {
					display: block;
					color: #fbe849;
					border: 1px solid #937c36;
					border-radius: 5px;
					margin: 0 auto;
					width: px2rem(172rem);
					height: px2rem(62rem);
					line-height: px2rem(62rem);
					margin-top: px2rem(12rem);
				}
				img {
					width: px2rem(137rem);
					height: px2rem(132rem);
				}
			}
			.ewm {
				flex: 1;
				text-align: center;
				img {
					width: px2rem(160rem);
					height: px2rem(160rem);
					border: 4px solid #debc77;
				}
				.tx {
					color: #ffddb5;
					font-size: px2rem(24rem);
					margin-top: px2rem(15rem);
				}
			}
		}
	}

	.ftBtn {
		display: flex;
		margin-top: px2rem(28rem);
		background: #000;
		padding: px2rem(20rem) 0;
		text-align: center;
		.fh {
			flex: 1;
		}
		.gz {
			flex: 1;
			a {
				display: inline-block;
			}
		}

		img {
			width: px2rem(306rem);
			height: px2rem(105rem);
		}
	}

	.copyright {
		text-align: center;
		margin-top: px2rem(15rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}

	.modalPage {
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.8;
		position: fixed;
		left: 0;
		top: 0;
		img {
			width: px2rem(367rem);
			height: px2rem(426rem);
			position: absolute;
			right: px2rem(30rem);
			top: px2rem(64rem);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/game/result.vue